// Must stay first: the SDK resolves its env, and configures Amplify, on import.
import "./sdkEnv";
import { createClient, SignaloidClient } from "@signaloid/cloud-compute-engine-client";
import { MAX_REALTIME_RECONNECT_ATTEMPTS } from "./realtimeConstants";

/*
 *	Single SDK instance. Initialized with email auth so the SDK and the
 *	rest of the app share the same Amplify session.
 */

// SDK REST timeout is a fixed 10s (no override). Fine post-WS-migration: long
// work is async over the realtime channel; heavy ops (plot/upload) set their own.
//
const apiEndpoint: string | undefined = import.meta.env.VITE_SIGNALOID_API_URL;
const realtimeDomain = import.meta.env.MODE === "production" ? "realtime.signaloid.io" : "realtime.signaloid.dev";
export const sdk: SignaloidClient = createClient(
	{ method: "email" },
	{
		overrideEndpoints: {
			...(apiEndpoint ? { api: apiEndpoint } : {}),
			websocket: `wss://${realtimeDomain}/event/realtime`,
			host: realtimeDomain,
			publicWebsocket: `wss://public.${realtimeDomain}/event/realtime`,
			publicHost: `public.${realtimeDomain}`,
		},
		maxReconnectAttempts: MAX_REALTIME_RECONNECT_ATTEMPTS,
	},
);

// Mirrors the SDK's internal channel naming (waitForTask/waitForBuild strip the
// id prefix, e.g. `usr_abc` -> `abc`); the raw id subscribes to a dead channel.
// TODO: drop this once the SDK exports idToChannelName (or a subscribe helper that owns the channel name).
export function idToChannelName(id: string): string {
	const parts = id.split("_");
	return parts.length > 1 ? parts[1] : id;
}
